import { defineMessage } from 'services/localization';

export const messages = {
    remainingBalance: defineMessage('purchase_order_line_remaining_bremainingbalanceb'),
};
